import { Link } from "react-router-dom";
import { logo, closeicon, down } from "assets/icons/index";

import LangButton from "components/languageButton/LangButton";
import {
  ABOUT_PATH,
  BOARD_OF_DIRECTORS_PATH,
  CONTACT_US_PATH,
  HUMANITARIAN_CASES_PATH,
  INTERNAL_PROJECTS_PATH,
  NEWS_PATH,
  ORGANIZATIONAL_STRUCTURE_PATH,
  ORPHAN_SPONSORSHIP_PATH,
  OUR_ACHIEVEMENTS_PATH,
  SEASONAL_PROJECTS_PATH,
  VIDEOS_PATH,
  VISION_AND_MISSION_PATH,
} from "Routes/paths";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface MobileMenuTypes {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileMenu = ({ show, setShow }: MobileMenuTypes) => {
  const { t, i18n } = useTranslation();
  const [organization, setOrganization] = useState(false);
  const [projects, setProjects] = useState(false);
  const [media, setMedia] = useState(false);

  return (
    <div
      data-aos={`${i18n.language === "en" ? "fade-right" : "fade-left"}`}
      data-aos-duration="600"
      className={
        show
          ? "lg:hidden p-[30px] absolute left-0 top-0 z-10 w-full h-screen bg-white flex flex-col gap-[30px] duration-300"
          : "absolute top-0 left-[-100%] w-full h-screen duration-300"
      }
    >
      {/* logo and close button  */}
      <div className="flex items-center justify-between">
        <Link to={"/"} className="w-[100px] flex items-center justify-center">
          <img src={logo} alt="logo" />
        </Link>
        <div onClick={() => setShow(false)}>
          <img src={closeicon} alt="" />
        </div>
      </div>

      {/* links section  */}
      <div className="flex flex-col gap-[20px]">
        {/* Our Organization */}
        <div
          onClick={() => setOrganization(!organization)}
          className={`flex flex-col gap-[15px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[14px] text-second_color`}
        >
          <div className="flex items-center gap-[10px]">
            {t("Our Organization")} <img src={down} alt="" />
          </div>
          <div
            className={
              organization
                ? `${
                    i18n.language === "en" ? "ml-[10px]" : "mr-[10px]"
                  } flex flex-col gap-[8px]`
                : `hidden `
            }
          >
            <Link to={ABOUT_PATH}>
              &bull; {t("About Al Etihad Charity Foundation")}
            </Link>
            <Link to={VISION_AND_MISSION_PATH}>
              &bull; {t("Vision And Mission")}
            </Link>
            {/* <Link to={ORGANIZATIONAL_STRUCTURE_PATH}>
              &bull; {t("Organizational Structure")}
            </Link> */}
            <Link to={BOARD_OF_DIRECTORS_PATH}>
              &bull; {t("Board of Directors")}
            </Link>
            <Link to={OUR_ACHIEVEMENTS_PATH}>
              &bull; {t("Our Achievements")}
            </Link>

            <Link to={CONTACT_US_PATH}>&bull; {t("Contact Us")}</Link>
          </div>
        </div>

        {/* Charity Projects */}
        <div
          className={`flex flex-col gap-[15px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[14px] text-second_color`}
        >
          <div
            onClick={() => setProjects(!projects)}
            className="flex items-center gap-[10px]"
          >
            {t("Charity Projects")} <img src={down} alt="" />
          </div>
          <div
            className={
              projects
                ? `${
                    i18n.language === "en" ? "ml-[10px]" : "mr-[10px]"
                  } flex flex-col gap-[8px]`
                : "hidden"
            }
          >
            <Link to={INTERNAL_PROJECTS_PATH}>
              &bull; {t("Internal Projects")}{" "}
            </Link>
            <Link to={SEASONAL_PROJECTS_PATH}>
              &bull; {t("Seasonal Projects")}{" "}
            </Link>
          </div>
        </div>

        {/* Humanitarian Cases */}
        <Link
          to={HUMANITARIAN_CASES_PATH}
          className={`flex items-center gap-[10px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[14px] text-second_color`}
        >
          {" "}
          {t("Humanitarian Cases")}
        </Link>

        {/* Orphans Sponsorship */}
        <Link
          to={ORPHAN_SPONSORSHIP_PATH}
          className={`flex items-center gap-[10px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[14px] text-second_color`}
        >
          {" "}
          {t("Orphans Sponsorship")}
        </Link>

        {/* Media Center */}
        <div
          className={`flex flex-col gap-[15px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[14px] text-second_color`}
        >
          <div
            onClick={() => setMedia(!media)}
            className="flex items-center gap-[10px]"
          >
            {t("Media Center")} <img src={down} alt="" />
          </div>
          <div
            className={
              media
                ? `${
                    i18n.language === "en" ? "ml-[10px]" : "mr-[10px]"
                  } flex flex-col gap-[8px]`
                : "hidden"
            }
          >
            <Link to={NEWS_PATH}>&bull; {t("News")} </Link>
            <Link to={VIDEOS_PATH}>&bull; {t("Videos")} </Link>
          </div>
        </div>
      </div>

      {/* language section  */}
      <div className="pt-[15px] border-t-[1px]">
        <LangButton />
      </div>
    </div>
  );
};

export default MobileMenu;
